<template>
  <div class="document-container">
    <div class="columns">
      <div class="column is-three-quarters">
        <dm-download-options :dmobj="transaction" :dmobjmatch="transaction.dmBatch"
          :dmobjid="transactionId" :parentPage.sync="parentPage"/>
      </div>
      <div class="column is-one-quarter">
        <dm-download-history :dmobj="transaction"
          :dmobjid="transactionId" :parentPage="parentPage"/>
      </div>
    </div>
    <div class="document" v-if="parentPage.showExtract">
      <div class="header">
        <es-header>
          <template #header>
            <div class="header-title" v-if="parentPage && parentPage.extractInfo && parentIndex">Extract File({{ (parentPage.extractInfo.length - parentIndex.length) }})</div>
            <div class="header-title" v-else>Extract File(s)</div>
          </template>
          <template #actions>
            <ul>
              <li class="p-narrow no-border">
              </li>
              <li class="p-narrow no-border">
              </li>
            </ul>
          </template>
        </es-header>
      </div>
      <div class="content" >
        <es-loader v-if="parentPage.loading === true"/>
        <table v-else class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>
                Extract Date
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                Match Type
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                Location Info
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                Match Status
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                School Year
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                Record Count
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                Extract Name
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>
                Extract Status
                <font-awesome-icon :icon="['fas', 'sort']"/>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr  v-if="parentPage.extractInfo && ((showParent && extract.parent)
                || (showParent && !extract.parent)
                || (!showParent && !extract.parent)
                || parentPage.extractInfo.length === 1)"
                v-for="extract in parentPage.extractInfo" :key="extract.identifier">
              <td>
                <div v-if="extract">
                  <div  class="has-text-weight-bold">
                    {{ extract.extractDate | formatDateMMDDYYYY }}
                  </div>
                  <div class="has-text-grey-light">
                    {{ extract.extractDate | formatTime }}
                  </div>
                </div>
                <div v-else>
                  &nbsp;
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold">
                  {{ transaction.program.description }}
                </div>
              </td>
              <td>
                <div class="is-flex flex-direction--column">
                  <div v-if="transaction.districtCode && transaction.schoolCode" >
                    <router-link
                      :to="{
                        name: 'DmDistrictInfoDetails',
                        params: { code: transaction.district.code  },
                      }"
                      class="has-text-weight-bold has-text-primary" style="font-size:14px">
                      {{ transaction.district.location.name }}
                    </router-link>
                    <span class="padding-left--small has-text-grey">({{ transaction.district.code }})</span>
                    <div v-if="transaction.school">
                      <router-link
                        :to="{
                          name: 'DmSchoolInfoDetails',
                          params: {
                            districtCode: transaction.district.code,
                            schoolCode: transaction.school.code,
                          },
                        }"
                        class="is-italic">
                        {{ transaction.school.location.name }}
                      </router-link>
                      <span class="padding-left--small has-text-grey is-italic">({{ transaction.school.code }})</span>
                    </div>
                    <div v-else>
                      <span class="is-italic has-text-grey">All Schools</span>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold">
                  {{ String(parentPage.matchStatusSelect) | getStatDesc }}
                  <!-- Near Match System Label needed -->
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold">
                  {{ transaction.schoolYear }}
                </div>
              </td>
              <td class="table-action">
                <div class="has-text-weight-bold">
                  {{ extract.processedCount }} of {{ extract.totalCount }}
                </div>
              </td>
              <td>
                <div>
                  {{ extract.fileName }}
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold" v-if="extract.status">
                  {{ String(extract.status) | statusDescription }}
                </div>
                <div class="has-text-weight-bold" v-else>
                  QUEUED
                </div>
              </td>
              <td class="action">
                <div v-if="extract.status === 3 && hasModule('DRMCH:DWNLD:DOWNLOAD')">
                  <a v-if="extract.fileId"
                    :href="buildSplitUrl(extract.fileId, extract.fileName)">
                    Download
                  </a>
                </div>
                <div v-else>
                  <a @click="refreshExtract">
                    Refresh
                  </a>
                </div>
              </td>
            </tr>
            <tr v-if="!parentPage.extractInfo">
              <td>
                <div v-if="parentPage.extractDate">
                  <div  class="has-text-weight-bold">
                    {{ this.parentPage.extractDate | formatDateMMDDYYYY }}
                  </div>
                  <div class="has-text-grey-light">
                    {{ this.parentPage.extractDate | formatTime }}
                  </div>
                </div>
                <div v-else>
                  &nbsp;
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold">
                  QUEUED
                </div>
              </td>
              <td>
                QUEUED
              </td>
              <td>
                <div class="has-text-weight-bold">
                  QUEUED
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold">
                  QUEUED
                </div>
              </td>
              <td class="table-action">
                <div class="has-text-weight-bold">
                 of
                </div>
              </td>
              <td>
                <div>
                  {{ parentPage.extractName }}{{ parentPage.extractNameExt }}
                </div>
              </td>
              <td>
                <div class="has-text-weight-bold" >
                  QUEUED
                </div>
              </td>
              <td class="action">
                <div>
                  <a @click="refreshExtract">
                    Refresh
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import DmDownloadOptions from '@/components/DmDownloadOptions.vue';
import DmDownloadHistory from '@/components/DmDownloadHistory.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsLoader from '@/components/EsLoader.vue';
import DateUtils from '@/mixins/DateUtils';
import PermissionManager from '@/mixins/PermissionManager';
import { mapGetters } from 'vuex';

library.add(
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
);

export default {

  components: {
    DmDownloadOptions,
    DmDownloadHistory,
    EsForm,
    EsHeader,
    EsFormActions,
    EsLoader,
  },
 mixins: [DateUtils, PermissionManager],
 props:[
   'transaction',
   'transactionId',
 ],
 data() {
    return {
      parentPage: {
        url: 'directmatch/transactions/download',
        linkageId: null,
        notSearch: true,
        showExtract: false,
        loading: null,
        userId: null,
        userEmail: null,
        extractName: null,
        extractNameExt: null,
        extractStatus: null,
        downloadFileId: null,
        extractDate: null,
        studentId: null,
        districts: null,
        schools: null,
        programs: null,
        schoolYear: null,
        split: null,
        extractInfo: null,
        parentFileName: null,
        downloadIds: [],
        downloadIdNames: [],
      },
      showParent: null,
      downloadAllFiles: true,
      parentIndex: [],
    };
  },
  created() {
    this.parentPage.split = this.properties['DIRECTMATCH-SPLIT_BATCH_OPTION_FOR_EXTRACTS'];
  },
  mounted() {

  },
  methods: {
    getDistrict(code) {
      return axios.get(`/districts/${code}`);
    },
    getSchool(schoolCode) {
      var tmpDistrictCode;
      const splitSchoolCodes = [];
      if (this.schoolCodes.length > 1) {
        for (let i = 0; i < this.schoolCodes.length; i += 1) {
          splitSchoolCodes.push(this.schoolCodes[i].split(/[:]+/));
          if (splitSchoolCodes[i][0] === schoolCode) {
            tmpDistrictCode = splitSchoolCodes[i][1];
          }
        }
      } else {
        splitSchoolCodes.push(this.schoolCodes[0].split(/[:]+/));
        if (splitSchoolCodes[0][0] === schoolCode) {
          tmpDistrictCode = splitSchoolCodes[0][1];
        }
      }
      return axios.get(`districts/${tmpDistrictCode}/schools/${schoolCode}`);
    },
    getSchoolCodes() {
      return this.schoolCodes.map(code => code.split(/[:]+/)[0]);
/*
      const splitSchoolCodes = [];
      const codes = [];
      for (let i = 0; i < this.schoolCodes.length; i += 1) {
        splitSchoolCodes.push(this.schoolCodes[i].split(/[:]+/));
        codes.push(splitSchoolCodes[i][0]);
      }
      return codes;
*/
    },
    async downloadAll(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    downloadFile(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    buildAllUrl(extractName) {
      return `${axios.defaults.baseURL}directmatch/transactions/downloadall/${extractName}`;
    },
    buildSplitUrl(dlFileId, splitFileName) {
      let tmpUrl = `${axios.defaults.baseURL}directmatch/transactions/download/${dlFileId}?extractFileName=${splitFileName}`;
      return tmpUrl;
    },
    async refreshExtract() {
      try {
        this.parentPage.loading=true;
        const res = await axios.get(`directmatch/transactions/extractstatus?extractFileName=${this.parentPage.extractName}`);
        this.parentPage.extractInfo = res.data;

        this.downloadAllFiles = true;

        this.parentPage.downloadIds = new Array(0);
        this.parentPage.downloadIdNames = new Array(0);
        this.parentIndex = new Array(0);

        for (let i = 0; i < this.parentPage.extractInfo.length; i++) {

          console.log("1: " + this.downloadAllFiles);
          if (i === 0) {
            this.parentPage.extractStatus = ""+this.parentPage.extractInfo[i].status;
            this.parentPage.downloadFileId = this.parentPage.extractInfo[i].fileId;
          }

          this.showParent = !(this.parentPage.split === "LEA");

          if (!this.parentPage.extractInfo[i].parent)
            this.downloadAllFiles = this.downloadAllFiles && (this.parentPage.extractInfo[i].status === 3 || this.parentPage.extractInfo[i].status === 4)

          if (this.parentPage.extractInfo[i].status === 3 || this.parentPage.extractInfo[i].status === 4) {
            const inArray = (element) => element == this.parentPage.extractInfo[i].fileId;
            console.log("find: " +this.parentPage.downloadIds.findIndex(inArray));
            if (this.parentPage.downloadIds.findIndex(inArray) == -1) {
              this.parentPage.downloadIds.push(this.parentPage.extractInfo[i].fileId);
              this.parentPage.downloadIdNames.push(this.parentPage.extractInfo[i].fileName);
            }
          }
          console.log("this.parentPage.extractInfo[i].parent: " + i + " - " + this.parentPage.extractInfo[i].parent);
          if (this.parentPage.extractInfo[i].parent) {
            this.parentPage.parentFileName = this.parentPage.extractInfo[i].fileName;
            this.parentIndex.push(i);

            console.log("found parent: " + this.parentIndex);
          }

          console.log("parent index: " + this.parentIndex);

          if (this.parentIndex || this.parentIndex != null ) {
            console.log("downloadAllFiles:sizeequal - " + this.downloadAllFiles + ":" + (this.parentPage.downloadIds.length === (this.parentPage.extractInfo.length - this.parentIndex.length)))
            if (this.downloadAllFiles && (this.parentPage.downloadIds.length > 0) && (this.parentPage.downloadIds.length === (this.parentPage.extractInfo.length - this.parentIndex.length))) {
              for(let pi = 0; pi < this.parentIndex.length; pi++){
                this.parentPage.extractInfo[pi].status = 3;
              }
            }
          }

          console.log("4: " + this.downloadAllFiles);
          if (this.parentPage.extractInfo[i].districtCode === "MULTIPLE") {
            this.parentPage.extractInfo[i].district = "Multiple Districts";
          } else if (this.parentPage.extractInfo[i].districtCode) {
            try {
              const code = this.parentPage.extractInfo[i].districtCode;
              console.log("4: "+ code);
              await this.getDistrict(code).then((response) => {
                this.parentPage.extractInfo[i].district = response.data;
              });
            } catch (error) {
              console.log("in block4: " + error);
              this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
              this.showNotification('danger', [this.apiMsg]);
            }
          }
          console.log("4a: " + this.downloadAllFiles);
          if (this.parentPage.extractInfo[i].schoolCode === "MULTIPLE") {
            this.parentPage.extractInfo[i].school = "Multiple Schools";
          } else if (this.parentPage.extractInfo[i].schoolCode) {
            try {
              const code = this.parentPage.extractInfo[i].schoolCode;
              console.log("4a: "+ code);
              await this.getSchool(code).then((response) => {
                this.parentPage.extractInfo[i].school = response.data;
              });
            } catch (error) {
              console.log("in block4a: " + error);
              this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
              this.showNotification('danger', [this.apiMsg]);
            }
          }
          console.log("5: " + this.downloadAllFiles);
          if (!this.parentPage.extractInfo[i].processedCount) {
            this.parentPage.extractInfo[i].processedCount = 0;
          }

          if (!this.parentPage.extractInfo[i].totalCount) {
            this.parentPage.extractInfo[i].totalCount = 0;
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.parentPage.loading=false;
      }
      this.parentPage.showExtract = true;
    },
  },
  filters: {
    statusDescription(value) {
      let stat = 'N/A';
      if (value === '0') {
        stat = 'PROCESSING';
      } else if (value === '1') {
        stat = 'PROCESSING';
      } else if (value === '2') {
        stat = 'INTERRUPTED';
      } else if (value === '3') {
        stat = 'COMPLETED';
      } else if (value === '4') {
        stat = 'DOWNLOADED';
      }
      return stat;
    },
    getStatDesc(statType) {

      var stat = "N/A";

      if (statType === "1" || statType === "14" || statType === "16") {
        stat = 'Match';
      } else if(statType === "2") {
        stat = 'Near Match';
        // Near Match System Label needed
      } else if(statType === "4" || statType === "15") {
        stat = 'No Match';
      } else if(statType === "13" || statType === "17" || statType === "90") {
        stat = 'Cancel';
      }

      return stat;
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
      properties: 'propertiesModule/properties',
    }),
    showDLLink() {
      return this.parentPage.extractInfo.every(extract => extract.status === 3 || extract.status === '3');
    },
  },
};
</script>

  <style lang="sass" scoped>
    .margin-bottom
      margin-bottom: 1rem
    .sort-by
      padding-right: 18px
      position: relative
      color: #777
      text-decoration: none
      &:before, &:after
      border: 4px solid transparent
      content: ""
      display: block
      height: 0
      right: 5px
      top: 50%
      position: absolute
      width: 0
      &:before
        border-bottom-color: #999
        margin-top: -9px
        &:after
          border-top-color: #999
          margin-top: 1px
    .header-container
      margin-bottom: 1rem
    .no-radius
      border-radius: 0
      background-color: #F2F2F2
      font-weight: normal
    .selected-option
      background-color: #ccc
      font-weight: bold
    .fields-container
      margin-left: 30px
    .text-align--left
      text-align: left !important
    .column-header
      padding-left: 0px
    .text-align--right
      text-align: right !important
    .text-align--left
      text-align: left !important
  </style>
